(function(){
 'use strict';
 var dialog=document.querySelector('[data-nt-fitment-dialog]'),entry=document.querySelector('[data-nt-fitment-entry]');
 if(!document.querySelector('[data-nt-home-pdp]')||!dialog||!entry||!dialog.showModal)return;
 var check=dialog.querySelector('[data-nt-fitment-modal-check]'),proceed=dialog.querySelector('[data-nt-fitment-continue]'),approved=new Set(),pending=null,opener=null,scheduled=false;
 var buttons='[data-nt-add-to-cart],[data-nt-buy-now],[data-nt-mobile-cart],[data-nt-mobile-add],.nt-pc-sticky-purchase__add,.nt-pc-sticky-purchase__buy';
 function current(){return document.querySelector('[data-nt-product]');}
 function normalize(value){return String(value).toLowerCase().replace(/[^a-z0-9]/g,'');}
 function info(root){
  var field=root&&root.querySelector('[data-nt-fitment]');
  if(!field||field.dataset.customerSelectsFitment==='true')return null;
  var brand=root.dataset.vehicleBrand,models=(root.dataset.vehicleModels||'').split('||').map(function(s){return s.trim();}).filter(Boolean),years=(root.dataset.modelYears||'').split(',').map(function(s){return s.trim();}).filter(Boolean);
  if(!brand||!models.length||!years.length)return null;
  return {root:root,brand:brand,models:models.join(' / '),years:years.length>1?years[0]+'–'+years[years.length-1]:years[0],key:[normalize(brand),models.map(normalize).sort().join(','),years.map(normalize).sort().join(',')].join('|')};
 }
 function mount(){
  var root=current(),data=info(root);if(!data)return;
  var title=root.querySelector('.nt-pdp__title-row');if(!title)return;
  if(!title.querySelector('[data-nt-fitment-open]'))title.appendChild(entry.content.firstElementChild.cloneNode(true));
  root.dataset.ntFitmentModalReady='true';
 }
 function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(function(){scheduled=false;mount();});}
 function intent(button){return button.matches('[data-nt-buy-now],[data-nt-mobile-add],.nt-pc-sticky-purchase__buy')?'buy':'add';}
 function open(data,button){
  if(dialog.open)return;
  pending={root:data.root,key:data.key,button:button};opener=button||document.activeElement;
  dialog.querySelector('[data-nt-fitment-modal-brand]').textContent=data.brand;
  dialog.querySelector('[data-nt-fitment-modal-model]').textContent=data.models;
  dialog.querySelector('[data-nt-fitment-modal-years]').textContent=data.years;
  check.checked=false;proceed.disabled=true;
  proceed.textContent=dialog.querySelector('[data-nt-fitment-label-'+(button?intent(button):'confirm')+']').textContent;
  dialog.showModal();dialog.querySelector('[data-nt-fitment-close]').focus({preventScroll:true});
 }
 function cancel(){pending=null;if(dialog.open)dialog.close();}
 function gate(event,button){
  var root=current(),data=info(root);
  if(!data||approved.has(data.key)||button.disabled||root.dataset.currentAvailable!=='true')return;
  event.preventDefault();event.stopImmediatePropagation();open(data,button);
 }
 document.addEventListener('click',function(event){
  if(!(event.target instanceof Element))return;
  var review=event.target.closest('[data-nt-fitment-open]');
  if(review){var data=info(current());if(data){event.preventDefault();open(data,null);}return;}
  var button=event.target.closest(buttons);
  if(button)gate(event,button);
 },true);
 document.addEventListener('submit',function(event){
  var root=current();if(!root||!root.contains(event.target)||!event.target.matches('form[action*="/cart/add"]'))return;
  var button=event.submitter&&event.submitter.matches(buttons)?event.submitter:root.querySelector('[data-nt-add-to-cart]');if(button)gate(event,button);
 },true);
 check.addEventListener('change',function(){proceed.disabled=!check.checked;});
 proceed.addEventListener('click',function(){
  if(!check.checked||!pending)return;
  var data=info(current()),action=pending;
  if(!data||data.root!==action.root||data.key!==action.key){cancel();return;}
  approved.add(data.key);
  var original=data.root.querySelector('[data-nt-fitment-confirm]');if(original){original.checked=true;original.dispatchEvent(new Event('change',{bubbles:true}));}
  pending=null;dialog.close();
  if(action.button&&action.button.isConnected&&!action.button.disabled)queueMicrotask(function(){action.button.click();});
 });
 dialog.querySelectorAll('[data-nt-fitment-close]').forEach(function(button){button.addEventListener('click',cancel);});
 dialog.addEventListener('cancel',function(){pending=null;});
 dialog.addEventListener('close',function(){pending=null;if(opener&&opener.isConnected)opener.focus({preventScroll:true});opener=null;});
 dialog.addEventListener('click',function(event){if(event.target!==dialog)return;var box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)cancel();});
 document.addEventListener('nt:product:unload',function(event){if(pending&&pending.root===event.target)cancel();},true);
 document.addEventListener('nt:product:mount',mount);
 new MutationObserver(schedule).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
 mount();
})();
